<template>
  <div class="border_bottom">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-full justify-right">
        <h2
          class="pl-2"
        >{{ editRoute ? $t('labels.edit_escalation_barrier_factor') : $t('labels.add_escalation_barrier_factor') }}</h2>
      </div>
    </div>
    <div class="addedit-service center">
      <form @submit.prevent="checkValidation()" autocomplete="off">
        <vx-card class="addedit-service-card">
          <div class="vx-row w-full m-0">
            <div class="vx-col sm: w-full p-0">
              <label>{{ $t('labels.name')}}</label>
              <vs-input
                type="text"
                class="w-full mt-1"
                name="escalation_factor_barrier_name"
                maxlength="250"
                v-model="name"
                icon-no-border
                :placeholder="$t('labels.escalation_factor_barrier_name')"
                v-validate="'required'"
              />
              <span class="text-danger text-sm">{{ errors.first('escalation_factor_barrier_name') }}</span>
            </div>
            <div class="vx-col sm: w-full p-0 mt-4">
              <label>{{ $t('labels.mitigating_barriers')}}</label>
              <v-select
                multiple
                name="mitigating_barrier"
                v-model="parent_mitigating"
                :options="parentMitigating"
                :reduce="parentMitigating => parentMitigating.id"
                label="name"
                :closeOnSelect="false"
                class="mt-1"
              />
            </div>
            <div class="vx-col sm: w-full p-0 mt-4">
              <label>{{ $t('labels.preventative_barriers')}}</label>
              <v-select
                multiple
                name="preventative_barrier"
                v-model="parent_preventative"
                :options="parentPreventative"
                :reduce="parentPreventative => parentPreventative.id"
                label="name"
                :closeOnSelect="false"
                class="mt-1"
              />
            </div>
          </div>
          <div class="mt-6 btn-lead flex justify-center">
            <vs-button
              class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
              :disabled="button_loading"
              id="create-escalation-factor-barrier"
              button="submit"
            >{{ editRoute ? $t('labels.update_escalation_barrier_factor') : $t('labels.add_escalation_barrier_factor') }}</vs-button>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      parentMitigating: [],
      parent_mitigating: [],
      parentPreventative: [],
      parent_preventative: []
    };
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.getPreventativebarrier();
    this.getMitigatingBarrier();
    this.setValidationMessage();
    if (this.editRoute) {
      this.getEscalationfactorBarrier();
    }
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.createUpdateEscalationfactorBarriers();
        }
      });
    },
    async createUpdateEscalationfactorBarriers() {
      let input = {
        name: this.name,
        preventative_barrier_ids: this.parent_preventative,
        mitigating_barrier_ids: this.parent_mitigating
      };
      let url = this.editRoute
        ? "/escalation-factor-barriers/update/" + this.editRoute
        : "/escalation-factor-barriers/create";
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#create-escalation-factor-barrier",
        true
      );
      if (response) {
        this.$router.push({ name: "EscalationfactorBarriers" });
      }
    },
    async getEscalationfactorBarrier() {
      let response = await this.getHTTPGetResponse(
        "/escalation-factor-barriers/get/" + this.editRoute
      );
      if (response) {
        let data = response.data;
        let escalation_factor_barrier = data.escalation_factor_barrier;
        this.name = escalation_factor_barrier.name;
        let filteredSection = [];
        for (
          var i = 0;
          i < escalation_factor_barrier.mitigating_barriers.length;
          i++
        ) {
          filteredSection.push(
            escalation_factor_barrier.mitigating_barriers[i].id
          );
        }
        this.parent_mitigating = filteredSection;

        let filteredSec = [];
        for (
          var i = 0;
          i < escalation_factor_barrier.preventative_barriers.length;
          i++
        ) {
          filteredSec.push(
            escalation_factor_barrier.preventative_barriers[i].id
          );
        }
        this.parent_preventative = filteredSec;
      }
    },
    async getMitigatingBarrier() {
      let input = {
        name: this.parent_mitigating
      };
      let response = await this.getHTTPPostResponse(
        "/mitigating-barriers/list",
        input
      );
      if (response) {
        let mitigating_req = response.data.mitigating_barriers;
        let filteredMitigating = [];
        for (var i = 0; i < mitigating_req.length; i++) {
          let obj = { id: mitigating_req[i].id, name: mitigating_req[i].name };
          filteredMitigating.push(obj);
        }
        this.parentMitigating = filteredMitigating;
      }
    },
    async getPreventativebarrier() {
      let input = {
        name: this.parent_preventative
      };
      let response = await this.getHTTPPostResponse(
        "/preventative-barriers/list",
        input
      );
      if (response) {
        let preventative_req = response.data.preventative_barriers;
        let filteredPreventative = [];
        for (var i = 0; i < preventative_req.length; i++) {
          let obj = {
            id: preventative_req[i].id,
            name: preventative_req[i].name
          };
          filteredPreventative.push(obj);
        }
        this.parentPreventative = filteredPreventative;
      }
    },
    goBack() {
      history.back();
    }
  }
};
</script>